import React, { useState } from "react";

import { Box, Button, Checkbox, FormControlLabel, Modal, Stack } from "@mui/material";
import whiteRocketGreenCircle from "assets/images/rocket-green-circle.png";
import { useDevice, useNavigate } from "hooks";
import { useUserActions } from "store";

interface Props {
  isOpen: boolean;
  close: () => void;
}
export const CompleteProfile: React.FC<Props> = ({ isOpen, close }) => {
  const navigate = useNavigate();
  const { isMobile } = useDevice();
  const [isChecked, setIsChecked] = useState<boolean>(false);

  const { hideCompletionPopupAction } = useUserActions();

  const handleClose = () => {
    if (isChecked) {
      hideCompletionPopupAction();
    }
    close();
  };

  return (
    <Modal open={isOpen} onClose={handleClose}>
      <Stack
        sx={{
          width: isMobile ? "90%" : "470px",
          maxWidth: "470px",
          p: isMobile ? "20px" : "30px",
          boxShadow: "-2px 2px 15px -2px rgba(0, 0, 0, 0.25)",
          bgcolor: "white",
          borderRadius: "8px",
          gap: "14px",
          maxHeight: isMobile ? "90vh" : "auto",
          overflow: "auto",
          ...style
        }}
      >
        <Box sx={{ fontSize: "16px", fontWeight: 500, p: "7px 0 7px 0", borderBottom: "1px solid #DAE0E2" }}>
          Complete Your Profile
        </Box>
        <Stack
          gap="15px"
          alignItems="center"
          alignSelf="center"
          sx={{
            p: isMobile ? "20px 0" : "30px 0",
            width: isMobile ? "100%" : "247px",
            img: {
              width: isMobile ? "80px" : "102px",
              height: isMobile ? "80px" : "102px"
            }
          }}
        >
          <img src={whiteRocketGreenCircle} alt="Man with speaker" loading="lazy" />
          <Box
            sx={{
              maxWidth: isMobile ? "100%" : "250px",
              textAlign: "center",
              mb: "16px",
              fontSize: isMobile ? "14px" : "16px",
              px: isMobile ? "10px" : 0
            }}
          >
            Add details to help team members recognize you and collaborate more effectively
          </Box>
        </Stack>
        <Box sx={{ borderTop: "1px solid #DAE0E2", pt: "10px" }}>
          <Stack
            direction={isMobile ? "column" : "row"}
            alignItems={isMobile ? "stretch" : "center"}
            justifyContent="space-between"
            gap={isMobile ? "15px" : 0}
          >
            <FormControlLabel
              sx={{
                ".MuiFormControlLabel-label": { fontSize: isMobile ? "12px" : "14px" },
                m: 0
              }}
              control={<Checkbox checked={isChecked} onChange={(e) => setIsChecked(e.target.checked)} />}
              label="Don't Show Again"
            />
            <Stack direction={isMobile ? "column" : "row"} gap="10px" width={isMobile ? "100%" : "auto"}>
              <Button
                sx={{
                  p: isMobile ? "8px 16px" : "0 10px",
                  minWidth: isMobile ? "100%" : "auto",
                  color: "#26A6AE"
                }}
                onClick={handleClose}
              >
                Close
              </Button>
              <Button
                onClick={() => {
                  handleClose();
                  navigate({ route: "socialProfile" });
                }}
                variant="contained"
                sx={{ minWidth: isMobile ? "100%" : "auto" }}
              >
                Complete Profile
              </Button>
            </Stack>
          </Stack>
        </Box>
      </Stack>
    </Modal>
  );
};

const style = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  outline: "none"
};
